import type { Locale } from "./locales";

const zhCN = {
  "meta.title": "SoftMap 商业搜索工作台",
  "meta.description": "SoftMap 商业搜索聊天工作台",
  "locale.switcher": "界面语言",
  "locale.zh-CN": "简体中文",
  "locale.zh-TW": "繁体中文",
  "locale.en": "English",
  "common.comingSoon": "即将开放",
  "common.featureComingSoon": "{name}功能即将开放",
  "common.retry": "重试",
  "common.backWorkspace": "返回工作台",
  "common.traceID": "追踪编号：{traceID}",
  "common.loading": "加载中…",
  "common.close": "关闭",
  "common.cancel": "取消",
  "common.available": "可用",
  "common.unavailableSoon": "即将开放",

  "auth.email": "邮箱",
  "auth.password": "密码",
  "auth.setPassword": "设置密码",
  "auth.confirmPassword": "确认密码",
  "auth.passwordRule": "至少 8 位，不限制字符组合。",
  "auth.existingAccountPasswordNotice": "如果邮箱已有账号，验证后将更新为此密码。",
  "auth.passwordMismatch": "两次输入的密码不一致。",
  "auth.passwordWeak": "密码长度须为 8–1024 位。",
  "auth.login": "登录",
  "auth.loggingIn": "正在登录…",
  "auth.register": "注册",
  "auth.registerAccount": "注册账号",
  "auth.loginAccount": "登录账号",
  "auth.backLogin": "返回登录",
  "auth.forgotPassword": "忘记密码",
  "auth.changePassword": "修改密码",
  "auth.recoverPassword": "找回密码",
  "auth.recoverAccount": "恢复账号",
  "auth.registeredEmail": "注册邮箱",
  "auth.sendRecovery": "发送恢复邮件",
  "auth.sending": "正在发送…",
  "auth.submitting": "正在提交…",
  "auth.loginCopy": "登录后继续使用商业搜索工作台。",
  "auth.registerCopy": "创建 SoftMap 用户账号，验证邮箱后即可开始搜索。",
  "auth.recoveryCopy": "输入注册邮箱和新密码，我们会发送账号验证码。",
  "auth.verificationCopy": "请输入邮箱收到的 6 位验证码。",
  "auth.verificationCode": "邮箱验证码",
  "auth.verifying": "正在验证…",
  "auth.verifyComplete": "验证并完成注册",
  "auth.changeEmail": "更换邮箱",
  "auth.closeDialog": "关闭账号窗口",
  "auth.serviceUnavailable": "账号服务暂时不可用，请稍后重试。",
  "auth.loginInvalid": "账号或密码无法验证。",
  "auth.registrationInvalid": "注册信息无法验证，请检查后重试。",
  "auth.codeSent": "验证码已发送，请在 15 分钟内填写。",
  "auth.codeSentLong": "验证码已发送，请在 15 分钟内完成验证。",
  "auth.codeInvalid": "验证码无效或已过期，请重新获取。",
  "auth.verified": "邮箱验证成功，请登录。",
  "auth.verifiedActivate": "邮箱验证成功，请登录完成账号激活。",
  "auth.verifyUnavailable": "验证服务暂时不可用，请稍后重试。",
  "auth.codeExhausted": "验证码已失效，请关闭窗口后重新获取新验证码。",
  "auth.completedLoginManually": "验证已完成，请使用新密码登录。",
  "auth.recoverySent": "如果该邮箱已注册，我们会发送恢复邮件。",
  "auth.loginSucceeded": "登录成功",
  "auth.loginSucceededHome": "登录成功，当前首页已更新。请选择任务域继续。",
  "auth.noDynamicCode": "普通用户登录不需要后台动态码。",
  "auth.problem.expired": "会话已过期，请重新登录。",
  "auth.problem.unavailable": "身份服务暂时不可用，请稍后重试。",
  "auth.problem.callback_invalid": "登录回调无法验证，请重新开始登录。",
  "auth.problem.logout_unavailable": "退出服务暂时不可用，请稍后重试。",
  "auth.problem.verification_pending": "验证邮件已发送，完成验证后即可继续。",
  "auth.problem.verification_expired": "验证链接已过期，请重新发送验证邮件。",
  "auth.problem.recovery_expired": "账号恢复链接已失效，请重新开始恢复。",
  "auth.problem.registration_conflict": "该身份无法完成注册，请使用账号恢复。",
  "auth.resendVerification": "重新发送验证邮件",

  "nav.user": "用户导航",
  "nav.userWorkspace": "用户工作台",
  "nav.businessSearch": "商业搜索",
  "nav.entitlements": "套餐与额度",
  "nav.logout": "退出",

  "design.workspaceTitle": "商业搜索工作台",
  "design.history": "历史",
  "design.guestMode": "访客模式",
  "design.loggedIn": "已登录",
  "design.compatibility": "商业搜索工作台 {text}",
  "design.newChat": "新建对话",
  "design.openMenu": "打开菜单",
  "design.closeMenu": "关闭菜单",
  "chat.newConversation": "新建会话",
  "chat.recentConversations": "最近会话",
  "chat.deleteConversation": "删除会话",
  "chat.deleteConversationConfirm": "确定删除这条会话记录吗？删除后将从最近会话中移除。",
  "chat.historyLoading": "正在加载最近会话…",
  "chat.historyEmpty": "还没有历史会话",
  "chat.historyError": "最近会话暂时无法加载。",
  "chat.historyNoPreview": "暂无消息摘要",
  "chat.newDisabledActiveTask": "“{name}”仍在进行中，暂时不能新建会话。",
  "chat.readOnlyClosed": "此会话已关闭，仅供查看。",
  "chat.readOnlyOtherTask": "另一个会话的任务正在进行，此会话暂时只读。",
  "chat.findCustomer": "找客户",
  "chat.customerMap": "客户地图",
  "chat.customerDiscovery": "客户发现",
  "chat.pipeline": "商机管理",
  "chat.findProduct": "找产品",
  "chat.findVendor": "找厂商",
  "chat.noDomain": "未选择",
  "chat.chooseDomain": "选择可用功能",
  "chat.newConversationEyebrow": "开始新的探索",
  "chat.newConversationTitle": "这次想寻找什么？",
  "chat.newConversationCopy":
    "直接说说你的想法，我会帮你理清需求。也可以选择下面的功能开始。",
  "chat.intentCustomerDescription":
    "根据行业、地区和客户画像，发现值得跟进的潜在客户。",
  "chat.intentProductDescription":
    "从市场需求与供应信息中，筛选适合采购或销售的产品。",
  "chat.intentVendorDescription":
    "寻找具备目标产能、地区和合作条件的供应商与制造商。",
  "chat.selectIntentPlaceholder": "直接描述需求，或选择一个功能",
  "chat.defaultAssistantTitle": "SoftMap AI",
  "chat.acceptWorkflowProposal": "是，开始「{name}」",
  "chat.rejectWorkflowProposal": "不是",
  "chat.continueSearch": "按原条件继续",
  "chat.resetSearch": "重新设置条件",
  "chat.example": "示例",
  "chat.welcome": "告诉我你想找的行业、地区和客户类型。我会在对话里完成筛选。",
  "chat.inputPlaceholder": "描述你的业务、目标客户和地区",
  "chat.loginInputPlaceholder": "选择找客户，登录后开始会话",
  "chat.startInputPlaceholder": "先选择找客户，开始一个会话",
  "chat.loadingSession": "正在恢复会话状态…",
  "chat.retrySession": "重试读取会话",
  "chat.refreshCondition": "刷新条件状态",
  "chat.composerLabel": "聊天输入区",
  "chat.questionLabel": "商业问题",
  "chat.enterSend": "Enter 发送",
  "chat.help": "Shift+Enter 换行；整理条件不会创建任务或扣减额度。",
  "chat.genericHelp": "Shift+Enter 换行；等待态消息会恢复同一个工作流节点。",
  "chat.domainComing": "{name}即将开放，当前不会创建会话或预占额度。",
  "chat.currentDomain": "当前任务域：{name}",
  "chat.noResults": "结果",
  "chat.resultArea": "结果区域",
  "chat.closeResult": "关闭结果",
  "chat.cancelFlow": "取消流程",
  "chat.confirmContinue": "确认继续",
  "chat.collectReady": "条件已收齐。确认后继续执行吗？",
  "chat.confirming": "正在确认…",
  "chat.send": "发送",
  "chat.workflowStarted":
    "已启动「{name}」。工作流会按当前发布版本和你的实时授权继续执行。",
  "chat.workflowStartUnavailable":
    "当前工作流尚未完成配置或暂时无法启动，请先在后台完成发布和运行依赖配置。",
  "chat.conversationServiceUnavailable": "暂时无法回复，请稍后重试。已完成的工作流结果会保留。",
  "chat.workflowServiceUnavailable": "工作流服务暂时不可用，请稍后重试。",
  "chat.workflowConflict": "当前会话已发生变化，请刷新页面后再试。",
  "chat.workflowPreparing": "正在准备工作流…",
  "chat.messageSending": "发送中…",
  "chat.messageProcessing": "正在回复",
  "chat.messageRetry": "发送失败，点击重试",
  "chat.creditsEmptyTitle": "积分已用完",
  "chat.creditsEmptyCopy": "，充值或购买套餐后即可继续对话。",
  "chat.creditsTopUp": "充值积分",
  "chat.creditsEmptyPlaceholder": "积分不足，请先充值",
  "chat.workflowWaiting": "工作流正在等待你的输入。",
  "chat.workflowCompleted": "工作流已完成。",
  "chat.workflowFailed": "工作流执行失败，请重新开始。",
  "chat.collectDraftEnded": "好的，这次资料收集先到这里。你可以继续聊天或随时回来接着补充。",
  "chat.workflowRestoreMissing": "当前工作流会话暂时不可用，请重试。",
  "chat.workflowRestoreFailed": "工作流状态暂时无法恢复，请重试。",
  "chat.workflowChangedPreserved": "会话状态已经变化，已保留输入内容，请重试。",
  "design.primaryNav": "主导航",
  "design.chat": "对话",
  "design.insights": "数据洞察",
  "design.saved": "收藏夹",
  "design.settings": "设置",
  "design.accountCredits": "账号与 AI 积分",
  "design.aiCredits": "AI 积分",
  "design.creditsLoading": "正在加载…",
  "design.creditsUnavailable": "积分暂不可用",
  "design.creditRemaining": "AI 积分剩余比例",
  "design.loginToView": "登录后查看",
  "design.syncConversation": "同步会话",
  "design.accountSoon": "账号信息功能即将开放",
  "design.upgrade": "升级套餐",
  "design.upgradeSoon": "升级套餐功能即将开放",
  "design.sessionSoon": "会话切换功能即将开放",
  "design.newCustomer": "新对话",
  "design.conversation": "对话内容",
  "design.greeting":
    "你好！我是 SoftMap AI 助手。\n我可以帮你发现潜在客户、分析市场区域、推荐合适的客户名单。\n请告诉我你的目标或询问任何问题。",
  "design.sampleUser": "请帮我在湾仔区域寻找适合的咖啡供应商客户",
  "design.sampleAnswer": "好的！我在湾仔区域为你找到以下潜在咖啡供应商客户：",
  "design.resultLabel": "湾仔区域客户推荐结果",
  "design.mapPreview": "湾仔区域地图预览",
  "design.mapLabel": "湾仔区域地图",
  "design.fullMap": "查看完整地图 ↗",
  "design.fullMapSoon": "完整地图功能即将开放",
  "design.recommendations": "客户推荐（5）",
  "design.viewAll": "查看全部",
  "design.listSoon": "客户列表功能即将开放",
  "design.highMatch": "高匹配",
  "design.mediumMatch": "中匹配",
  "design.customerMeta": "距离 0.3 km · 咖啡豆供应商\n年营业额：HK$ 2.5M - 5M",
  "design.viewDetails": "查看详情",
  "design.detailsSoon": "客户详情功能即将开放",
  "design.inputLabel": "输入你的问题或需求",
  "design.inputPlaceholder": "输入你的问题或需求...",
  "design.attachment": "附件",
  "design.attachmentSoon": "附件功能即将开放",
  "design.send": "发送",
  "design.sendSoon": "消息发送功能即将开放",
  "design.disclaimer": "SoftMap AI 可能会出错，请核实重要信息。",
  "design.mobileNav": "移动端主导航",
  "design.more": "更多",
  "design.moreSoon": "更多功能即将开放",
  "design.closeLogin": "关闭登录窗口",
  "design.closeHistory": "关闭历史",
  "design.welcomeQuota": "欢迎额度 {quantity} 次",

  "ent.eyebrow": "套餐 / 额度",
  "ent.title": "套餐与额度",
  "ent.description":
    "各额度来源独立呈现，不合并为虚拟总余额。流水时间统一标注为香港时间。",
  "ent.sources": "额度来源",
  "ent.sourceCount": "{count} 个账户",
  "ent.welcome": "欢迎额度",
  "ent.personal": "个人每日",
  "ent.enterprise": "企业共享",
  "ent.spendable": "可消费",
  "ent.notInitialized": "尚未生成",
  "ent.historicalReserved": "历史预占",
  "ent.notInitializedCopy":
    "当日额度尚未生成；套餐配置为 {quota}，首次收费入口会按 canonical 规则初始化。",
  "ent.available": "可用",
  "ent.reserved": "预占",
  "ent.used": "已用",
  "ent.hkBusinessDate": "香港业务日 {date}",
  "ent.lifetime": "终身账期",
  "ent.noPackage": "无套餐 / v{version}",
  "ent.emptySources": "当前没有已授权的额度来源。",
  "ent.memberUsage": "企业成员用量",
  "ent.dailyLimit": "每日上限",
  "ent.remaining": "剩余",
  "ent.activeReservations": "活动预占",
  "ent.activeReservationsTitle": "按来源显示的活动预占",
  "ent.sourceReservationCount": "{count} 个来源",
  "ent.emptyReservations": "当前没有活动预占。",
  "ent.ledger": "额度流水",
  "ent.recentLedger": "最近流水",
  "ent.entryCount": "{count} 条",
  "ent.eventType": "事件类型",
  "ent.allEvents": "全部事件",
  "ent.sourceFilter": "额度来源",
  "ent.allSources": "全部来源",
  "ent.clearFilters": "清除筛选",
  "ent.applyFilters": "应用筛选",
  "ent.retryRefresh": "重试刷新",
  "ent.tableEvent": "事件",
  "ent.tableSource": "来源与账期",
  "ent.tableQuantity": "数量与变更",
  "ent.tableFacts": "业务事实",
  "ent.tableTime": "发生时间",
  "ent.noTaskReference": "无任务引用",
  "ent.noFilteredEntries": "没有符合筛选条件的流水，可清除筛选后重试。",
  "ent.noEntries": "还没有额度流水。零余额仍会显示在上方来源卡中。",
  "ent.loadMore": "加载更多",
  "ent.retryLoadMore": "重试加载更多",
  "ent.loadMoreFailed": "更多流水暂时无法加载，已保留当前内容。",
  "ent.refreshFailed": "额度资料暂时无法刷新，请重试。",
  "ent.forbiddenTitle": "无法查看此额度资料",
  "ent.unavailableTitle": "额度服务暂时不可用",
  "ent.forbiddenCopy": "当前会话没有可执行的额度读取范围。",
  "ent.unavailableCopy": "我们没有把依赖失败显示成零余额，请稍后重试。",
  "ent.loadingLabel": "正在加载套餐与额度",
  "ent.event.grant": "已发放",
  "ent.event.reset": "每日重置",
  "ent.event.reserve": "已预占",
  "ent.event.settle": "已使用",
  "ent.event.release": "已退回",
  "ent.event.adjustment": "人工调整",
  "ent.reason.welcome_verified_email": "邮箱验证欢迎额度",
  "ent.reason.personal_daily_reset": "个人每日额度重置",
  "ent.reason.personal_task_reserve": "个人任务预占",
  "ent.reason.personal_task_settle": "个人任务结算",
  "ent.reason.personal_task_release": "个人任务退回",
  "ent.reason.enterprise_daily_reset": "企业每日额度重置",
  "ent.reason.enterprise_task_reserve": "企业任务预占",
  "ent.reason.enterprise_task_settle": "企业任务结算",
  "ent.reason.enterprise_task_release": "企业任务退回",
  "ent.reason.staff_correction": "重复发放修正",
  "ent.reason.staff_compensation": "服务补偿",
  "ent.reason.staff_promotion": "活动奖励",
  "ent.release.cancelled": "任务已取消",
  "ent.release.failed": "任务失败",
  "ent.release.timed_out": "任务超时",
  "ent.release.zero_results": "任务无结果",
} as const;

export type MessageKey = keyof typeof zhCN;
type Catalog = Record<MessageKey, string>;

const zhTW: Catalog = Object.fromEntries(
  Object.entries(zhCN).map(([key, value]) => [
    key,
    value
      .replaceAll("简体中文", "簡體中文")
      .replaceAll("繁体中文", "繁體中文")
      .replaceAll("账号", "帳號")
      .replaceAll("账户", "帳戶")
      .replaceAll("登录", "登入")
      .replaceAll("注册", "註冊")
      .replaceAll("验证", "驗證")
      .replaceAll("链接", "連結")
      .replaceAll("服务", "服務")
      .replaceAll("暂时", "暫時")
      .replaceAll("稍后", "稍後")
      .replaceAll("重试", "重試")
      .replaceAll("恢复", "恢復")
      .replaceAll("额度", "額度")
      .replaceAll("来源", "來源")
      .replaceAll("预占", "預佔")
      .replaceAll("退回", "退還")
      .replaceAll("当前", "目前")
      .replaceAll("会话", "對話")
      .replaceAll("对话", "對話")
      .replaceAll("用户", "使用者")
      .replaceAll("工作台", "工作臺")
      .replaceAll("新建", "新增")
      .replaceAll("商业", "商業")
      .replaceAll("搜索", "搜尋")
      .replaceAll("客户", "客戶")
      .replaceAll("发现", "發現")
      .replaceAll("地区", "地區")
      .replaceAll("筛选", "篩選")
      .replaceAll("发送", "傳送")
      .replaceAll("产品", "產品")
      .replaceAll("厂商", "廠商")
      .replaceAll("供应商", "供應商")
      .replaceAll("制造商", "製造商")
      .replaceAll("输入", "輸入")
      .replaceAll("问题", "問題")
      .replaceAll("查看", "檢視")
      .replaceAll("地图", "地圖")
      .replaceAll("设置", "設定")
      .replaceAll("历史", "歷史")
      .replaceAll("开放", "開放")
      .replaceAll("加载", "載入")
      .replaceAll("数据", "資料")
      .replaceAll("状态", "狀態")
      .replaceAll("发生", "發生")
      .replaceAll("时间", "時間")
      .replaceAll("编号", "編號")
      .replaceAll("继续", "繼續")
      .replaceAll("邮件", "郵件")
      .replaceAll("密码", "密碼")
      .replaceAll("创建", "建立")
      .replaceAll("业务", "業務")
      .replaceAll("已经", "已經")
      .replaceAll("没有", "沒有")
      .replaceAll("个", "個")
      .replaceAll("条", "筆")
      .replaceAll("无", "無")
      .replaceAll("为", "為")
      .replaceAll("与", "與")
      .replaceAll("活动", "活動")
      .replaceAll("显示", "顯示")
      .replaceAll("独立", "獨立")
      .replaceAll("合并", "合併")
      .replaceAll("虚拟", "虛擬")
      .replaceAll("标注", "標註")
      .replaceAll("消费", "消費")
      .replaceAll("调整", "調整")
      .replaceAll("发生", "發生")
      .replaceAll("时间", "時間")
      .replaceAll("类型", "類型")
      .replaceAll("数量", "數量")
      .replaceAll("业务", "業務")
      .replaceAll("事实", "事實")
      .replaceAll("来源", "來源")
      .replaceAll("权限", "權限")
      .replaceAll("范围", "範圍")
      .replaceAll("内容", "內容")
      .replaceAll("说明", "說明")
      .replaceAll("选择", "選擇")
      .replaceAll("应用", "應用")
      .replaceAll("清除", "清除")
      .replaceAll("最近", "最近"),
  ]),
) as Catalog;

const en: Catalog = {
  "meta.title": "SoftMap Business Search Workspace",
  "meta.description": "SoftMap conversational business search workspace",
  "locale.switcher": "Interface language",
  "locale.zh-CN": "Simplified Chinese",
  "locale.zh-TW": "Traditional Chinese",
  "locale.en": "English",
  "common.comingSoon": "Coming soon",
  "common.featureComingSoon": "{name} is coming soon",
  "common.retry": "Retry",
  "common.backWorkspace": "Back to workspace",
  "common.traceID": "Trace ID: {traceID}",
  "common.loading": "Loading…",
  "common.close": "Close",
  "common.cancel": "Cancel",
  "common.available": "Available",
  "common.unavailableSoon": "Coming soon",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.setPassword": "Set password",
  "auth.confirmPassword": "Confirm password",
  "auth.passwordRule":
    "Use at least 8 characters. No character combination is required.",
  "auth.existingAccountPasswordNotice":
    "If this email already has an account, verification will replace its password.",
  "auth.passwordMismatch": "The passwords do not match.",
  "auth.passwordWeak":
    "The password must contain 8–1024 characters.",
  "auth.login": "Sign in",
  "auth.loggingIn": "Signing in…",
  "auth.register": "Register",
  "auth.registerAccount": "Create account",
  "auth.loginAccount": "Sign in",
  "auth.backLogin": "Back to sign in",
  "auth.forgotPassword": "Forgot password",
  "auth.changePassword": "Change password",
  "auth.recoverPassword": "Recover password",
  "auth.recoverAccount": "Recover account",
  "auth.registeredEmail": "Registered email",
  "auth.sendRecovery": "Send recovery email",
  "auth.sending": "Sending…",
  "auth.submitting": "Submitting…",
  "auth.loginCopy": "Sign in to continue using the business search workspace.",
  "auth.registerCopy":
    "Create a SoftMap account and verify your email to start searching.",
  "auth.recoveryCopy":
    "Enter your registered email and a new password. We will send an account verification code.",
  "auth.verificationCopy": "Enter the 6-digit code sent to your email.",
  "auth.verificationCode": "Email verification code",
  "auth.verifying": "Verifying…",
  "auth.verifyComplete": "Verify and finish registration",
  "auth.changeEmail": "Use another email",
  "auth.closeDialog": "Close account dialog",
  "auth.serviceUnavailable":
    "The account service is temporarily unavailable. Please try again later.",
  "auth.loginInvalid": "The email or password could not be verified.",
  "auth.registrationInvalid":
    "The registration details could not be verified. Please review them and retry.",
  "auth.codeSent": "A verification code was sent. Enter it within 15 minutes.",
  "auth.codeSentLong":
    "A verification code was sent. Complete verification within 15 minutes.",
  "auth.codeInvalid":
    "The verification code is invalid or expired. Request a new one.",
  "auth.verified": "Email verified. Please sign in.",
  "auth.verifiedActivate": "Email verified. Sign in to activate your account.",
  "auth.verifyUnavailable":
    "Verification is temporarily unavailable. Please try again later.",
  "auth.codeExhausted":
    "This code is no longer valid. Close the dialog and request a new one.",
  "auth.completedLoginManually":
    "Verification is complete. Sign in with your new password.",
  "auth.recoverySent":
    "If the email is registered, recovery instructions will be sent.",
  "auth.loginSucceeded": "Signed in",
  "auth.loginSucceededHome": "Signed in. Choose a task domain to continue.",
  "auth.noDynamicCode":
    "Regular user sign-in does not require a staff security code.",
  "auth.problem.expired": "Your session expired. Please sign in again.",
  "auth.problem.unavailable":
    "The identity service is temporarily unavailable. Please try again later.",
  "auth.problem.callback_invalid":
    "The sign-in callback could not be verified. Start again.",
  "auth.problem.logout_unavailable":
    "Sign-out is temporarily unavailable. Please try again.",
  "auth.problem.verification_pending":
    "Verification was sent. Complete it to continue.",
  "auth.problem.verification_expired":
    "The verification link expired. Send a new verification email.",
  "auth.problem.recovery_expired":
    "The account recovery link expired. Start recovery again.",
  "auth.problem.registration_conflict":
    "This identity cannot complete registration. Use account recovery.",
  "auth.resendVerification": "Resend verification email",
  "nav.user": "User navigation",
  "nav.userWorkspace": "User workspace",
  "nav.businessSearch": "Business search",
  "nav.entitlements": "Plan & usage",
  "nav.logout": "Sign out",
  "design.workspaceTitle": "Business search workspace",
  "design.history": "History",
  "design.guestMode": "Guest mode",
  "design.loggedIn": "Signed in",
  "design.compatibility": "Business search workspace {text}",
  "design.newChat": "New conversation",
  "design.openMenu": "Open menu",
  "design.closeMenu": "Close menu",
  "chat.newConversation": "New conversation",
  "chat.recentConversations": "Recent conversations",
  "chat.deleteConversation": "Delete conversation",
  "chat.deleteConversationConfirm": "Delete this conversation? It will be removed from recent conversations.",
  "chat.historyLoading": "Loading recent conversations…",
  "chat.historyEmpty": "No conversation history yet",
  "chat.historyError": "Recent conversations could not be loaded.",
  "chat.historyNoPreview": "No message preview",
  "chat.newDisabledActiveTask": "“{name}” is still in progress. You cannot start a new conversation yet.",
  "chat.readOnlyClosed": "This conversation is closed and read-only.",
  "chat.readOnlyOtherTask": "A task is running in another conversation. This conversation is read-only for now.",
  "chat.findCustomer": "Find customers",
  "chat.customerMap": "Customer map",
  "chat.customerDiscovery": "Customer discovery",
  "chat.pipeline": "Pipeline",
  "chat.findProduct": "Find products",
  "chat.findVendor": "Find vendors",
  "chat.noDomain": "Not selected",
  "chat.chooseDomain": "Choose an available workflow",
  "chat.newConversationEyebrow": "START A NEW SEARCH",
  "chat.newConversationTitle": "What would you like to find?",
  "chat.newConversationCopy":
    "Choose an available workflow. SoftMap will start it according to its published access configuration.",
  "chat.intentCustomerDescription":
    "Discover prospects worth pursuing by industry, region, and customer profile.",
  "chat.intentProductDescription":
    "Filter products suited to buying or selling from market demand and supply signals.",
  "chat.intentVendorDescription":
    "Find suppliers and manufacturers matching your capacity, region, and partnership needs.",
  "chat.selectIntentPlaceholder": "Describe your request or choose a workflow",
  "chat.defaultAssistantTitle": "SoftMap AI",
  "chat.acceptWorkflowProposal": "Yes, start “{name}”",
  "chat.rejectWorkflowProposal": "No",
  "chat.continueSearch": "Continue with these conditions",
  "chat.resetSearch": "Reset conditions",
  "chat.example": "Example",
  "chat.welcome":
    "Tell me the industry, region, and customer type you want. I’ll filter them in the conversation.",
  "chat.inputPlaceholder":
    "Describe your business, target customers, and region",
  "chat.loginInputPlaceholder": "Choose Find customers and sign in to start",
  "chat.startInputPlaceholder": "Choose Find customers to start a conversation",
  "chat.loadingSession": "Restoring conversation state…",
  "chat.retrySession": "Retry loading conversation",
  "chat.refreshCondition": "Refresh condition state",
  "chat.composerLabel": "Chat input",
  "chat.questionLabel": "Business question",
  "chat.enterSend": "Enter to send",
  "chat.help":
    "Shift+Enter for a new line; organizing conditions does not create a task or spend credits.",
  "chat.genericHelp":
    "Shift+Enter for a new line; waiting messages resume the same workflow node.",
  "chat.domainComing":
    "{name} is coming soon; no conversation or reservation will be created.",
  "chat.currentDomain": "Current task domain: {name}",
  "chat.noResults": "Results",
  "chat.resultArea": "Results area",
  "chat.closeResult": "Close results",
  "chat.cancelFlow": "Cancel workflow",
  "chat.confirmContinue": "Confirm and continue",
  "chat.collectReady": "The details are complete. Continue with this workflow?",
  "chat.confirming": "Confirming…",
  "chat.send": "Send",
  "chat.workflowStarted":
    "{name} has started. The workflow will continue using its current published release and your live access.",
  "chat.workflowStartUnavailable":
    "This workflow is not fully configured or temporarily unavailable. Complete its publication and runtime dependencies in Staff, then retry.",
  "chat.conversationServiceUnavailable": "Unable to reply right now. Please retry shortly. Completed workflow results are preserved.",
  "chat.workflowServiceUnavailable":
    "The workflow service is temporarily unavailable. Please try again later.",
  "chat.workflowConflict":
    "This conversation changed. Refresh the page and try again.",
  "chat.workflowPreparing": "Preparing the workflow…",
  "chat.messageSending": "Sending…",
  "chat.messageProcessing": "Replying",
  "chat.messageRetry": "Failed to send. Click to retry",
  "chat.creditsEmptyTitle": "You’re out of credits",
  "chat.creditsEmptyCopy": ". Top up or choose a plan to continue chatting.",
  "chat.creditsTopUp": "Top up credits",
  "chat.creditsEmptyPlaceholder": "Add credits to continue",
  "chat.workflowWaiting": "The workflow is waiting for your input.",
  "chat.workflowCompleted": "The workflow is complete.",
  "chat.workflowFailed": "The workflow failed. Start again.",
  "chat.collectDraftEnded": "Okay, we’ll pause this information collection for now. You can keep chatting or come back to continue anytime.",
  "chat.workflowRestoreMissing":
    "The current workflow conversation is temporarily unavailable. Please retry.",
  "chat.workflowRestoreFailed":
    "The workflow state could not be restored. Please retry.",
  "chat.workflowChangedPreserved":
    "The conversation changed. Your input was preserved; please retry.",
  "design.primaryNav": "Primary navigation",
  "design.chat": "Conversation",
  "design.insights": "Insights",
  "design.saved": "Saved",
  "design.settings": "Settings",
  "design.accountCredits": "Account and AI credits",
  "design.aiCredits": "AI credits",
  "design.creditsLoading": "Loading…",
  "design.creditsUnavailable": "Credits unavailable",
  "design.creditRemaining": "AI credits remaining",
  "design.loginToView": "Sign in to view",
  "design.syncConversation": "Sync conversations",
  "design.accountSoon": "Account details are coming soon",
  "design.upgrade": "Upgrade plan",
  "design.upgradeSoon": "Plan upgrades are coming soon",
  "design.sessionSoon": "Conversation switching is coming soon",
  "design.newCustomer": "New conversation",
  "design.conversation": "Conversation",
  "design.greeting":
    "Hi! I’m the SoftMap AI assistant.\nI can help you discover prospects, analyze markets, and recommend customer lists.\nTell me your goal or ask a question.",
  "design.sampleUser": "Find suitable coffee supplier customers in Wan Chai",
  "design.sampleAnswer":
    "Here are potential coffee supplier customers I found in Wan Chai:",
  "design.resultLabel": "Wan Chai customer recommendations",
  "design.mapPreview": "Wan Chai map preview",
  "design.mapLabel": "Map of Wan Chai",
  "design.fullMap": "View full map ↗",
  "design.fullMapSoon": "The full map is coming soon",
  "design.recommendations": "Customer recommendations (5)",
  "design.viewAll": "View all",
  "design.listSoon": "The customer list is coming soon",
  "design.highMatch": "High match",
  "design.mediumMatch": "Medium match",
  "design.customerMeta":
    "0.3 km away · Coffee bean supplier\nAnnual revenue: HK$ 2.5M - 5M",
  "design.viewDetails": "View details",
  "design.detailsSoon": "Customer details are coming soon",
  "design.inputLabel": "Enter a question or requirement",
  "design.inputPlaceholder": "Enter a question or requirement...",
  "design.attachment": "Attach",
  "design.attachmentSoon": "Attachments are coming soon",
  "design.send": "Send",
  "design.sendSoon": "Message sending is coming soon",
  "design.disclaimer":
    "SoftMap AI can make mistakes. Verify important information.",
  "design.mobileNav": "Mobile navigation",
  "design.more": "More",
  "design.moreSoon": "More features are coming soon",
  "design.closeLogin": "Close sign-in dialog",
  "design.closeHistory": "Close history",
  "design.welcomeQuota": "Welcome quota: {quantity}",
  "ent.eyebrow": "PLAN / ENTITLEMENTS",
  "ent.title": "Plan & usage",
  "ent.description":
    "Each balance source is shown separately. Ledger times use Hong Kong time.",
  "ent.sources": "Balance sources",
  "ent.sourceCount": "{count} accounts",
  "ent.welcome": "Welcome quota",
  "ent.personal": "Personal daily",
  "ent.enterprise": "Enterprise shared",
  "ent.spendable": "Spendable",
  "ent.notInitialized": "Not initialized",
  "ent.historicalReserved": "Historical reservation",
  "ent.notInitializedCopy":
    "Today’s quota has not been initialized. The configured quota is {quota}; the first charge entry will initialize it using canonical rules.",
  "ent.available": "Available",
  "ent.reserved": "Reserved",
  "ent.used": "Used",
  "ent.hkBusinessDate": "Hong Kong business date {date}",
  "ent.lifetime": "Lifetime period",
  "ent.noPackage": "No package / v{version}",
  "ent.emptySources": "No authorized balance sources are available.",
  "ent.memberUsage": "Enterprise member usage",
  "ent.dailyLimit": "Daily limit",
  "ent.remaining": "Remaining",
  "ent.activeReservations": "Active reservations",
  "ent.activeReservationsTitle": "Active reservations by source",
  "ent.sourceReservationCount": "{count} sources",
  "ent.emptyReservations": "There are no active reservations.",
  "ent.ledger": "Usage ledger",
  "ent.recentLedger": "Recent ledger",
  "ent.entryCount": "{count} entries",
  "ent.eventType": "Event type",
  "ent.allEvents": "All events",
  "ent.sourceFilter": "Balance source",
  "ent.allSources": "All sources",
  "ent.clearFilters": "Clear filters",
  "ent.applyFilters": "Apply filters",
  "ent.retryRefresh": "Retry refresh",
  "ent.tableEvent": "Event",
  "ent.tableSource": "Source and period",
  "ent.tableQuantity": "Quantity and change",
  "ent.tableFacts": "Business facts",
  "ent.tableTime": "Occurred at",
  "ent.noTaskReference": "No task reference",
  "ent.noFilteredEntries":
    "No ledger entries match these filters. Clear the filters and retry.",
  "ent.noEntries":
    "No ledger entries yet. Zero balances remain visible in the source cards above.",
  "ent.loadMore": "Load more",
  "ent.retryLoadMore": "Retry loading more",
  "ent.loadMoreFailed":
    "More ledger entries could not be loaded. Current content was preserved.",
  "ent.refreshFailed": "Usage details could not be refreshed. Please retry.",
  "ent.forbiddenTitle": "You cannot view these usage details",
  "ent.unavailableTitle": "Usage service temporarily unavailable",
  "ent.forbiddenCopy":
    "The current session does not have permission to read these usage details.",
  "ent.unavailableCopy":
    "A dependency failure was not shown as a zero balance. Please try again later.",
  "ent.loadingLabel": "Loading plan and usage",
  "ent.event.grant": "Granted",
  "ent.event.reset": "Daily reset",
  "ent.event.reserve": "Reserved",
  "ent.event.settle": "Used",
  "ent.event.release": "Released",
  "ent.event.adjustment": "Manual adjustment",
  "ent.reason.welcome_verified_email": "Verified-email welcome quota",
  "ent.reason.personal_daily_reset": "Personal daily reset",
  "ent.reason.personal_task_reserve": "Personal task reservation",
  "ent.reason.personal_task_settle": "Personal task settlement",
  "ent.reason.personal_task_release": "Personal task release",
  "ent.reason.enterprise_daily_reset": "Enterprise daily reset",
  "ent.reason.enterprise_task_reserve": "Enterprise task reservation",
  "ent.reason.enterprise_task_settle": "Enterprise task settlement",
  "ent.reason.enterprise_task_release": "Enterprise task release",
  "ent.reason.staff_correction": "Duplicate grant correction",
  "ent.reason.staff_compensation": "Service compensation",
  "ent.reason.staff_promotion": "Promotion reward",
  "ent.release.cancelled": "Task cancelled",
  "ent.release.failed": "Task failed",
  "ent.release.timed_out": "Task timed out",
  "ent.release.zero_results": "No task results",
};

export const messages: Record<Locale, Catalog> = {
  "zh-CN": zhCN,
  "zh-TW": zhTW,
  en,
};

/** 插值只替换显式占位符；实体名和用户原文始终作为值传入，不会被当作翻译 key。 */
export function formatMessage(
  locale: Locale,
  key: MessageKey,
  values: Record<string, string | number> = {},
): string {
  const template = messages[locale]?.[key] ?? messages["zh-CN"][key] ?? key;
  return template.replace(/\{([a-zA-Z0-9_]+)\}/g, (_, name: string) =>
    Object.prototype.hasOwnProperty.call(values, name)
      ? String(values[name])
      : `{${name}}`,
  );
}
